<template lang="pug">
.template-envelopes-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1.text-overflow-ellipse(style='width: 90%') {{ getEnvelopeName(item) }}
      .mb-1 {{ $t('templateEnvelopesCardTable.id') }}: {{ item.hashid }}
      .mb-0 {{ $t('templateEnvelopesCardTable.creationDate') }}: {{ item.created_at | dateTime }}
      template(v-if='$root.isMobile')
        button(
          :disabled='!canEdit'
          :title='$t("templateEnvelopesCardTable.useTemplate")'
          @click.stop=''
          data-bs-target='#new-envelope-mobile-modal'
          data-bs-toggle='modal'
          style='position: absolute; top: 0.75rem; right: 0.45rem'
          type='button'
        )
          icon(name='file-pen')
        button(
          :title='$t("templateEnvelopesCardTable.editTemplate")'
          @click.stop=''
          data-bs-target='#new-envelope-mobile-modal'
          data-bs-toggle='modal'
          style='position: absolute; bottom: 2.75rem; right: 0.45rem'
        )
          icon(name='pen-to-square')
      template(v-else)
        button(
          :disabled='!canEdit'
          :title='$t("templateEnvelopesCardTable.useTemplate")'
          @click='cloneTemplateToDraft(item.id)'
          style='color: inherit; position: absolute; top: 0.75rem; right: 0.8rem'
        )
          icon(name='file-pen')
      button(
        :disabled='!canDelete'
        :title='$t("templateEnvelopesCardTable.delete")'
        @click.stop='selectedEnvelopeId = item.id'
        data-bs-target='#delete-envelope-modal'
        data-bs-toggle='modal'
        style='position: absolute; bottom: 1rem; right: 0.5rem'
      )
        icon.icon--canceled(name='trash-can')
    template(v-slot:table-head)
      th(style='width: 5%') {{ $t('templateEnvelopesCardTable.id') }}
      th(style='width: 60%') {{ $t('templateEnvelopesCardTable.name') }}
      th(style='width: 30%')
        .d-flex
          span.text {{ $t('templateEnvelopesCardTable.creationDate') }}
          button(
            @click='addSort("created_at", "DESC")'
            style='margin-top: -2px'
            v-show='sort.created_at === "ASC"'
          )
            icon.icon--blue(name='angle-down')
          button(
            @click='addSort("created_at", "ASC")'
            style='margin-top: -2px'
            v-show='sort.created_at !== "ASC"'
          )
            icon.icon--blue(name='angle-up')
      th(style='width: 5%')
        span.text {{ $t('templateEnvelopesCardTable.actions') }}
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.hashid }}
      td
        .template-envelopes-card-table__name.text-overflow-ellipse(
          :title='getEnvelopeName(item)'
        ) {{ getEnvelopeName(item) }}
      td {{ item.created_at | dateTime }}
      td
        .d-flex
          template(v-if='$root.isMobile')
            button(
              :disabled='!canEdit'
              :title='$t("templateEnvelopesCardTable.useTemplate")'
              @click.stop=''
              data-bs-target='#new-envelope-mobile-modal'
              data-bs-toggle='modal'
              type='button'
            )
              icon.icon--blue(name='file-pen')
          template(v-else)
            button.ms-2(
              :disabled='!canEdit'
              :title='$t("templateEnvelopesCardTable.useTemplate")'
              @click='cloneTemplateToDraft(item.id)'
              style='color: inherit'
            )
              icon.icon--blue(name='file-pen')
          template
            button.ms-2(
              :title='$t("templateEnvelopesCardTable.editTemplate")'
              @click='editCloneTemplateDraft(item.id)'
              style='color: inherit'
            )
              icon(name='pen-to-square')
          button.ms-2(
            :disabled='!canDelete'
            :title='$t("templateEnvelopesCardTable.delete")'
            @click.stop='selectedEnvelopeId = item.id'
            data-bs-target='#delete-envelope-modal'
            data-bs-toggle='modal'
          )
            icon.icon--canceled(name='trash-can')
  delete-envelope-modal(
    :envelope-id='selectedEnvelopeId'
    @refresh='$emit("item-deleted", selectedEnvelopeId)'
  )
  new-envelope-mobile-modal
</template>
<script>
import EnvelopeState from '@/enums/EnvelopeState';
import RecipientState from '@/enums/RecipientState';
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import EnvelopeSignaturesProgress from '@/ui/molecules/EnvelopeSignaturesProgress.vue';
import DeleteEnvelopeModal from '@/modules/business/components/organisms/modals/DeleteEnvelopeModal.vue';
import NewEnvelopeMobileModal from '@/modules/business/components/organisms/modals/NewEnvelopeMobileModal.vue';
import PermissionsService from '@/services/PermissionsService';
import ApiPermissions from '@/enums/ApiPermissions';
import alert from '@/modules/account/common/alert';

export default {
  name: 'ReceivedEnvelopesCardTable',
  components: {
    Icon,
    IconStatus,
    CardTable,
    EnvelopeSignaturesProgress,
    DeleteEnvelopeModal,
    NewEnvelopeMobileModal,
    EnvelopesService,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      EnvelopeState,
      RecipientState,
      sort: {
        created_at: '',
      },
      selectedEnvelopeId: '',
    };
  },
  computed: {
    canEdit() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.ENVELOPE_UPDATE
      );
    },
    canDelete() {
      return PermissionsService.can(
        this.$root.user,
        ApiPermissions.ENVELOPE_DELETE
      );
    },
  },
  methods: {
    addSort(column, type) {
      this.sort[column] = type;
      this.$emit('sort', {
        column: column,
        desc: type === 'DESC',
      });
    },
    checkNextOrderByColumnIsDesc(column) {
      if (column === this.sort.column) {
        return !this.sort.desc;
      }
      return false;
    },
    getEnvelopeName(item) {
      return item.title && item.title !== 'old' ? item.title : item.subject;
    },
    cloneTemplateToDraft(envelopeId) {
      if (!this.canEdit) {
        const action = this.$t('templateEnvelopesCardTable.useTemplate');
        alert.fireAlert(this.$t('insufficientPermission', { action: action }), {
          classes: 'alert-warning',
          tag: 'httpAlert',
          icon: 'triangle-exclamation',
        });
        return;
      }
      this.$loading(true);
      EnvelopesService.copyTo('draft', envelopeId)
        .then((response) => {
          this.$router.push({
            name: 'business.envelope.recipients',
            params: { id: response.data.id },
          });
        })
        .catch((error) => {
          const errorMessage = `${this.$t(
            'templateEnvelopesCardTable.error.useTemplate'
          )} ${error.response.data.message}`;
          alert.fireAlert(errorMessage, {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    editCloneTemplateDraft(envelopeId) {
      // for edit template - not send
      this.$loading(true);
      EnvelopesService.copyTo('template', envelopeId)
        .then((response) => {
          this.$router.push({
            name: 'business.envelope.documents',
            params: {
              id: response.data.id,
              isTemplate: true,
              isNewTemplate: false,
            },
          });
        })
        .catch((error) => {
          const errorMessage = `${this.$t(
            'templateEnvelopesCardTable.error.editTemplate'
          )} ${error.response.data.message}`;
          alert.fireAlert(errorMessage, {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style lang="stylus">
.template-envelopes-card-table__name
  max-width: 180px;
@media (min-width: 576px)
  .template-envelopes-card-table__name
    max-width: 180px
@media (min-width: 768px)
  .template-envelopes-card-table__name
    max-width: 180px
@media (min-width: 992px)
  .template-envelopes-card-table__name
    max-width: 500px
@media (min-width: 1200px)
  .template-envelopes-card-table__name
    max-width: 470px
@media (min-width: 1400px)
  .template-envelopes-card-table__name
    max-width: 640px
</style>
